import React from 'react';

const NewsLatter = () => {
    return (
        <div>

        </div>
    );
};

export default NewsLatter;